export default class Address {
    name = ""
    company = ""
    address = ""
    zip = ""
    city = ""
    note = ""
}